var _path, _circle, _circle2, _circle3, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef, memo } from "react";
const SvgResearchConnect = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.529 23.4752C13.0785 24.7885 14.7854 25.1234 15.7905 24.1151L26.3302 13.5411C27.4592 12.4085 26.8681 10.4746 25.2988 10.1666L8.99629 6.968C7.42698 6.6601 6.14893 8.22729 6.76622 9.70258L12.529 23.4752Z",
    fill: "#E2F2FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5001,
    cy: 8.9425,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.01,
    stroke: "#359FF4",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 24.5001,
    cy: 12.9425,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.01,
    stroke: "#359FF4",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5001,
    cy: 23.9425,
    r: 2.5,
    fill: "#D9D9D9",
    fillOpacity: 0.01,
    stroke: "#359FF4",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4644 11.2564L16.0001 16.9421",
    stroke: "#359FF4",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.0006 16.4423L12.5002 21.4423",
    stroke: "#359FF4",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5001 14.443L16.0001 16.443",
    stroke: "#359FF4",
    strokeWidth: 2
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgResearchConnect);
const Memo = /*#__PURE__*/memo(ForwardRef);
export default Memo;